import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../lib/api';
import BrandLogo from '../components/BrandLogo';

export default function AdminLogin() {
  const [email, setEmail] = useState('admin@goleicestershire.com');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function submit(e) {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const r = await api.post('/auth/login', { email, password });
      localStorage.setItem('gl_admin_token', r.data.token);
      localStorage.setItem('gl_admin_email', r.data.email);
      localStorage.setItem('gl_admin_role', r.data.role || 'admin');
      navigate('/admin');
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed');
    } finally { setLoading(false); }
  }

  return (
    <div className="min-h-screen bg-admin grid grid-cols-1 lg:grid-cols-2">
      <div className="hidden lg:flex relative bg-forest text-base p-16 flex-col justify-between">
        <div data-testid="admin-login-logo"><BrandLogo size="lg" dark /></div>
        <div>
          <h1 className="font-display text-5xl leading-tight max-w-md">Run your destination, end to end.</h1>
          <p className="mt-6 max-w-md text-base/80">Listings, events, packages, members and AI-written weekend digests — all from one dashboard.</p>
        </div>
        <div className="text-base/50 text-sm">Admin · Editorial control panel</div>
      </div>
      <div className="flex items-center justify-center p-8 lg:p-16">
        <form onSubmit={submit} className="w-full max-w-md bg-white border border-charcoal/10 rounded-3xl p-10">
          <div className="label text-heritage mb-3">Welcome back</div>
          <h2 className="font-display text-3xl mb-8">Sign in</h2>
          <label className="block text-sm font-semibold mb-2">Email</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email"
            className="w-full bg-admin border border-charcoal/15 rounded-xl px-4 py-3 mb-5 focus:outline-none focus:border-forest"/>
          <label className="block text-sm font-semibold mb-2">Password</label>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password"
            className="w-full bg-admin border border-charcoal/15 rounded-xl px-4 py-3 mb-6 focus:outline-none focus:border-forest"/>
          {error && <div className="text-heritage text-sm mb-4" data-testid="admin-login-error">{error}</div>}
          <button type="submit" disabled={loading} data-testid="admin-login-submit"
            className="w-full bg-charcoal text-base font-semibold py-3.5 rounded-xl hover:bg-charcoal/90 disabled:opacity-60">
            {loading ? 'Signing in...' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}
